import React from 'react';

import { Form, Radio } from 'antd';
import styled from 'styled-components';

import { CMA_SUMMARY_ROOM_TYPE_GROUPING, CMA_SUMMARY_ROOM_TYPE_GROUPING_LABELS } from 'components/CMASummary/constants';

import { useCMASummaryRoomTypeFilterContext } from './CMASummaryRoomTypeFilterContext';

const GroupingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;
  padding: 22px 20px;
  border-top: 1px solid var(--line-gray);
`;

const GroupingTitle = styled.span`
  font-family: var(--font-bold);
`;

const GroupingRadioGroup = styled(Radio.Group)`
  display: flex;
  gap: 16px;

  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin: 0;
    font-weight: 500;
  }

  .ant-radio-inner {
    width: 18px;
    height: 18px;
  }
`;

const CMASummaryRoomTypeFilterGrouping = () => (
  <GroupingContainer>
    <GroupingTitle>GROUP ROOM TYPE</GroupingTitle>
    <Form.Item name="groupingValue" noStyle>
      <GroupingRadioGroup>
        <Radio key={CMA_SUMMARY_ROOM_TYPE_GROUPING.GROUP} value={CMA_SUMMARY_ROOM_TYPE_GROUPING.GROUP}>
          Group
        </Radio>
        <Radio key={CMA_SUMMARY_ROOM_TYPE_GROUPING.DONT_GROUP} value={CMA_SUMMARY_ROOM_TYPE_GROUPING.DONT_GROUP}>
          Don't Group
        </Radio>
      </GroupingRadioGroup>
    </Form.Item>
  </GroupingContainer>
);

export default CMASummaryRoomTypeFilterGrouping;
